module.exports = __webpack_public_path__ + "img/2f_r_sobaichi@2x.363e3064.png";